import React, {useEffect, useState} from "react";
import {styled} from "@mui/material/styles";
import {Table} from "../App/components/Table";
import {TableHeader} from "../App/components/Table/TableHeader";
import {useDispatch, useSelector} from "react-redux";
import {FeedbackActions} from "./actions/feedback";
import {IRootState} from "../App/reducers/store";
import {Table as MUITable} from "@devexpress/dx-react-grid-material-ui";
import {FiltersActionsTypes} from "../App/interfaces/filter";
import {IMessage} from "./interfaces/feedback";
import {Search} from "@mui/icons-material";
import {Grid,} from "@mui/material";
import TextField from "../App/components/Input/TextField";
import Title from "../App/components/Table/Title";
import {useDebounce} from "use-debounce";
import {TableRow} from "@devexpress/dx-react-grid";
import {SourceChip} from "../App/components/SourceChip";

const PREFIX = 'Dialogues'

const classes = {
  content: `${PREFIX}-content`,
  inputContent: `${PREFIX}-inputContent`,
  tableRow: `${PREFIX}-tableRow`
}

const Content = styled(Grid)(() => ({
  height: "100%",
  padding: "1rem",
  overflow: "hidden",
  position: "relative",
  [`& .${classes.inputContent}`]: {
    width: "100%",
    height: 'calc(100vh - 163px)',
    minHeight: 'calc(100vh - 163px)',
    overflow: "overlay",
    overflowX: "hidden",
    background: 'white',
  },
  [`& .${classes.tableRow}`]: {
    cursor: "pointer",
    textDecoration: "none"
  }
}))

export function Messages(): JSX.Element | null {
  const dispatch: any = useDispatch()
  const {filter} = useSelector((state: IRootState) => state.filters.feedbackMessages)
  const [messages, setMessages] = useState<{data: Array<IMessage>, meta?: { total?: number | null }}>({data: [], meta: { total: null }})
  const [page, setPage] = useState(1)
  const [hiddenColumnNames, setHiddenColumnNames] = useState([]);
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState<string | null>(null)
  const [search] = useDebounce(value, 900);

  const columns = [
    {name: 'source', title: 'Источник'},
    {name: 'clientId', title: 'ID пользователя'},
    {name: 'created', title: 'Дата и время создания'},
    {name: 'message', title: 'Сообщение'},
  ]

  const [columnOrder, setColumnOrder] = useState([
    'source',
    'clientId',
    'created',
    'message'
  ])

  const [columnWidths, setColumnWidths] = useState([
    {columnName: 'source', width: 120},
    {columnName: 'clientId', width: 200},
    {columnName: 'created', width: 250},
    {columnName: 'message', width: 900},
  ])

  useEffect(() => {
    if (!loading) {
      const skip = (page - 1) * filter.take
      dispatch(FeedbackActions.messages({
        ...(filter.sort.name ? {
          sort: filter.sort.name,
          direction: filter.sort.direction,
        } : {}),
        take: filter.take,
        ...(skip ? {skip: skip} : {}),
        ...(!messages.meta?.total ? {meta: true} : {}),
        ...(filter.roles?.length ? {roles: filter.roles.join(',')} : {}),
        ...(search?.length ? {search: search} : {}),
      })).then((response: {
        data: [IMessage],
        meta?: {
          total?: number
        },
      }) => {
        setMessages({
          data: response.data,
          meta: response.meta ?? messages.meta
        })
        setLoading(true)
      })
    }
    // eslint-disable-next-line
  }, [loading])

  useEffect(() => {
    if (loading) {
      setLoading(false)
    }
    // eslint-disable-next-line
  }, [page])

  useEffect(() => {
    if (loading) {
      setPage(1)
      setLoading(false)
    }
    // eslint-disable-next-line
  }, [filter, search])

  const handlePageSizeChange = (newRowsPerPage: number) => {
    dispatch({
      type: FiltersActionsTypes.FEEDBACK_MESSAGES,
      payload: {
        ...filter,
        take: newRowsPerPage,
      }
    })
  }

  return loading ? (
    <Content>
      <Title
        title={"Обратная связь"}
        actions={[
          <TextField
            type="text"
            value={value}
            placeholder="Поиск: сообщение"
            icon={<Search />}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const value = event.target.value
              setValue(value.length ? value : '')
            }}
          />
        ]}
      />
      <Table
        meta={messages.meta}
        name={'feedbackMessages'}
        rows={messages.data.map((item: IMessage) => ({
          source: <SourceChip source={item.source} />,
          clientId: item.clientId,
          created: new Date(item.created).toLocaleString(),
          message: item.message,
        }))}
        columns={columns}
        page={{
          page: page,
          setPage: setPage,
          rowsPerPage: filter.take,
          handlePageSizeChange: handlePageSizeChange
        }}
        columnsSettings={{
          columnOrder: columnOrder,
          setColumnOrder: setColumnOrder,
          setColumnWidths: setColumnWidths,
          columnWidths: columnWidths,
          hiddenColumnNames: hiddenColumnNames,
          setHiddenColumnNames: setHiddenColumnNames
        }}
        tableHeader={TableHeader}
        filterActionType={FiltersActionsTypes.FEEDBACK_MESSAGES}
        getValues={FeedbackActions.filter}
        classInputContent={classes.inputContent}
        rowComponent={({row, tableRow, children}: { row: object, tableRow: TableRow, children: JSX.Element | null }) => (
          <MUITable.Row
            tableRow={tableRow}
            className={classes.tableRow}
            row={row}
            children={children}
            style={{'cursor': 'pointer'}}
          />
        )}
        filters={{
          actions: null,
        }}
      />
    </Content>
  ) : null
}